import React from 'react'
import { inject, observer } from 'src/core/store'
import { unix2date3 } from 'src/helper/time'
import './index.less'
import {
  apiGetGoldRecord,
  apiGetInvitedRecord,
  apiGoldNumber,
  apiWithdrawalGold,
  apiGetShareLink
} from 'src/helper/gold.js'
import { setUidToken } from 'src/helper/tool'
import lang from './lang'
import { getlangV2, setlang } from 'src/helper/getlang'
import { shareToLink, shareToWhatsapp } from 'src/helper/webviewFun'
import { history } from 'src/core/router'
import http from 'src/helper/http'
@inject('store')
@observer
export default class Gold extends React.Component {
  constructor(props) {
    super(props)
  }
  state = {
    number: 0,
    gold: [],
    record: [],
    current: 1,
    lang: lang.en,
    link: '',
    showInfo: false,
    language: 'en'
  }

  async componentDidMount() {
    this.$logEvent('invite_main_screen')
    await setUidToken(this.props.location.query)
    //this.getUesrInfoHave(language)
    let { language } = this.props.location.query
    language = await getlangV2(language, lang)
    this.setState({
      lang: setlang(language, lang)
    })
    this.handleGetGoldNumber()
    this.handleGetInvitedRecord()
    this.handleGetGoldRecord()
    const { res } = await apiGetShareLink()
    this.setState({ link: res })
  }

  async handleGetInvitedRecord() {
    const { res } = await apiGetInvitedRecord({ scroll: '0,30' })
    this.setState({
      gold: res.list
    })
  }
  async handleGetGoldRecord() {
    const { res } = await apiGetGoldRecord({ scroll: '0,30' })
    this.setState({
      record: res.list
    })
  }

  getUesrInfoHave = async (language) => {
    let res = await http.post('/web/invitecode/info')
    if (res.code == 0 && res.res.promoter == 1) {
      history.replace(`app/newInvitation`)
    } else {
      this.setState({ showInfo: true })
    }
  }
  //获取可提现金币数量
  async handleGetGoldNumber() {
    const res = await apiGoldNumber()
    this.setState({ number: res.res.gold || 0 })
  }

  //立即提现
  async handleWithdrawal() {
    this.$logEvent('invite_get_withdrawal')
    const res = await apiWithdrawalGold()
    console.log(res, '000000')
    this.handleGetGoldNumber()
  }

  async handleGetShareLink() {
    this.$logEvent('invite_copy_url')
    if (this.state.link && this.state.link != '' && this.state.link.indexOf('code=') > -1) {
      shareToLink(this.state.link)
    } else {
      const { res } = await apiGetShareLink()
      this.setState({ link: res })
      if (res.indexOf('code=') > -1) {
        shareToLink(res)
      }
    }
  }
  async handleGetShareWhatsapp() {
    this.$logEvent('invite_share_app')
    if (this.state.link && this.state.link != '' && this.state.link.indexOf('code=') > -1) {
      let link = this.state.link
      // if (brower.isIphone()) {
      //   link = link.replace('&code=','%26code%3d')
      // }
      shareToWhatsapp(this.state.lang.link + ' ' + link)
    } else {
      let { res } = await apiGetShareLink()
      this.setState({ link: res })
      if (res.indexOf('code=') > -1) {
        // if (brower.isIphone()) {
        //   res = res.replace('&code=','%26code%3d')
        // }
        shareToWhatsapp(this.state.lang.link + ' ' + res)
      }
    }
  }

  onGetTime(time) {
    const date = new Date(time * 1000)
    const year = date.getFullYear()
    const mounth = date.getMonth() + 1
    const day = date.getDate()
    const hour = date.getHours()
    const minutes = date.getMinutes()
    const second = date.getSeconds()

    return `${year}-${mounth.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`
  }

  // Join us on Yayya
  renderGold() {
    let { language } = this.state
    return (
      <div>
        <div className="container--title">
          <div>{this.state.lang.time}</div>
          <div>{this.state.lang.type}</div>
          <div>{this.state.lang.gold}</div>
        </div>
        {this.state.record.map((item, index) => {
          return (
            <div key={index} className="container--content">
              <div>{unix2date3(item.ts)}</div>
              <div>{item.type}</div>
              <div>{item.gold}</div>
            </div>
          )
        })}
      </div>
    )
  }
  renderInvited() {
    return (
      <div>
        <div className="container--title">
          <div>{this.state.lang.time}</div>
          <div></div>
          <div>{this.state.lang.number}</div>
        </div>
        {this.state.gold.map((item, index) => {
          return (
            <div key={index} className="container--content">
              <div>{item.statdate}</div>
              <div></div>
              <div>{item.number}</div>
            </div>
          )
        })}
      </div>
    )
  }

  render() {
    let { showInfo, lang } = this.state
    return (
      true && (
        <div className={`gold-wrapper ${this.state.language == 'ar' ? 'arlang' : ''}`}>
          <div className="rmeisehjh">
            <div className="tnenw">{lang.setTest}</div>
          </div>
        </div>
      )
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/share/index.js